import React from "react";
import { Text, Flex } from "@aws-amplify/ui-react";

import { PageIndex, PageTitle } from "../util/SEO";

import UserDetails from "./Settings.UserDetails";
import ButtonCard from "./Settings.ButtonCard";
import SupportCard from "./Settings.SupportCard";
import SocialsCard from "./Settings.SocialsCard";
import PrivacyAndTermsCard from "./Settings.Privacy&TermsCard";
import ReferralCard from "./Settings.ReferralCard";
import WinPremiumButton from "../features/referrals/components/WinPremiumButton";

export default function Settings() {
  PageTitle("Settings | Gibbly");
  PageIndex("noindex");

  return (
    <>
      {/* <DashboardLayout> */}
      <Flex
        padding={"medium"}
        paddingTop={"large"}
        gap={"zero"}
        direction={"column"}
      >
        <Flex justifyContent={"space-between"}>
          <Text id="pageTitle">Settings</Text>

          <Flex alignItems={"flex-end"}>
            <WinPremiumButton />
          </Flex>
        </Flex>

        <Flex
          width={"100%"}
          grow={1}
          direction={{ base: "column", medium: "row" }}
          paddingTop={"medium"}
        >
          <Flex direction="column" gap="small" width={"100%"}>
            <UserDetails />
            <ReferralCard />
          </Flex>
          <Flex direction="column" gap="small" width={"100%"}>
            <PrivacyAndTermsCard />
            <SupportCard />
            <SocialsCard />
            <ButtonCard />
          </Flex>
        </Flex>
      </Flex>
      {/* </DashboardLayout> */}
    </>
  );
}
